import { post, get } from "../network/index.js";

// 公共方法 -- 储存文件
const saveFile = (data) => {
  return post("/mercWebi/attachment/save", data);
};

// 公共方法 -- 上传图片
const uploadFiles = (data) => {
  return post("/mercWebi/attachment/uploadFiles", data);
};
// 公共方法 -- 附件列表
const filesList = (data) => {
  return post("/mercWebi/attachment/list", data);
};
const update = (data) => {
  return post("/mercWebi/attachment/update", data);
};

export default {
  saveFile,
  uploadFiles,
  filesList,
  update
};
